// extracted by mini-css-extract-plugin
export default {"CatalogCards":"Catalog_CatalogCards__zPIjH","CatalogCardsWrapper":"Catalog_CatalogCardsWrapper__adEYV"};